import { getAllegroResponsibleProducers } from '../../../api/allegro/responsibleproducer/responsibleProducer';
import { AllegroResponsibleProducer } from '../../../api/allegro/responsibleproducer/responsibleProducerTypes';
import { fetchAllPages, swallowUnauthorized } from '../utils';

const PAGE_SIZE = 1000;

export default async function fetchAllegroResponsibleProducers(
  marketplaceCode: string,
  signal?: AbortSignal,
): Promise<AllegroResponsibleProducer[]> {
  return swallowUnauthorized(
    () => fetchAllPages(
      async (offset, limit) => {
        const page = await getAllegroResponsibleProducers(marketplaceCode, offset, limit, signal);

        return {
          items: page.responsibleProducers,
          totalCount: page.totalCount,
        };
      },
      PAGE_SIZE,
    ),
    [],
  );
}
